export var EFieldSubType = /*#__PURE__*/function (EFieldSubType) {
  EFieldSubType["Icon"] = "icon";
  EFieldSubType["Pictures"] = "pictures";
  EFieldSubType["Layout"] = "layout";
  EFieldSubType["RadioButtonGroupSpliced"] = "radioButtonGroupSpliced";
  return EFieldSubType;
}({});